<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-12-12 09:21:12
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-06-29 18:06:27
 * @FilePath: \vue-new-hepha\src\views\DataQuery\BikeInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-select 
                v-if="userInfo.tenant_id == 1"
                class="query_field" 
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')" 
                :options="tenantOptions" 
                @change="handleSelectChange('tenant')"
            ></a-select>
            <a-select 
                class="query_field" 
                v-model:value="searchForm.frame_number" 
                allowClear
                showSearch
                :placeholder="t('cycling.frameNumber')" 
                :options="frameNumberOptions"
                @change="(val)=>handleSelectChange('frame_number',val)"
                @search="(val)=>getFrameAndMotor(val,'frame_number')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select>
            <a-select 
                class="query_field" 
                v-model:value="searchForm.assembly_code" 
                allowClear
                showSearch
                :placeholder="t('cycling.assemblyCode')" 
                :options="motorCodeOptions" 
                @change="(val)=>handleSelectChange('assembly_code',val)"
                @search="(val)=>getFrameAndMotor(val,'assembly_code')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select>
            <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
            <a-button type="primary" size="small" :loading="exportLoading" :disabled="exportBtnDisabled" @click="exportData">
                <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.exportData') }}
            </a-button>
        </div>

        <div class="general_info">
            <div class="info_left">
                <img v-if="general_info.picture_url == ''" class="img" src="@/assets/image/bike2.png" alt="" width="320" />
                <img v-if="!!general_info.picture_url" class="img bike_img" :src="general_info.picture_url" alt="" width="450" />

                <div class="block">
                    <div class="label">{{ $t('bikeInfo.driveUnitSoftwareVersion') }}</div>
                    <div class="value">{{ general_info.motor_software_version }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.batterySoftwareVersion') }}</div>
                    <div class="value">{{ general_info.battery_software_version }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.displaySoftwareVersion') }}</div>
                    <div class="value">{{ general_info.display_software_version }}</div>
                </div>
            </div>
            <div class="info_right">
                <div class="right_title">{{ $t('bikeInfo.generalInfo') }}</div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.sku') }}</div>
                    <div class="value">{{ general_info.sku }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.brand') }}</div>
                    <div class="value">{{ general_info.brand }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.bikeColor') }}</div>
                    <div class="value">{{ general_info.color }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.driveUnitModel') }}</div>
                    <div class="value">{{ general_info.drive_unit_model }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.modelYear') }}</div>
                    <div class="value">{{ general_info.model_year }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.bikeModel') }}</div>
                    <div class="value">{{ general_info.bike_model }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.placeOfProduction') }}</div>
                    <div class="value">{{ general_info.offline_origin }}</div>
                </div>
                <div class="block block_last">
                    <div class="label">{{ $t('bikeInfo.bikeOfflineTime') }}</div>
                    <div class="value">{{ general_info.offline_time }}</div>
                </div>

                <div class="block">
                    <div class="label">{{ $t('bikeInfo.driveUnitSerialNumber') }}</div>
                    <div class="value">{{ general_info.triple_id }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.batterySerialNumber') }}</div>
                    <div class="value">{{ general_info.battery_serial_number }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.displaySerialNumber') }}</div>
                    <div class="value">{{ general_info.display_serial_number }}</div>
                </div>
                <div class="block block_last">
                    <div class="label">{{ $t('bikeInfo.batteryKeySerialNumber') }}</div>
                    <div class="value">{{ general_info.key_serial_number }}</div>
                </div>

                <div class="block">
                    <div class="label">{{ $t('bikeInfo.driveUnitHardwareVersion') }}</div>
                    <div class="value">{{ general_info.motor_hardware_version }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.batteryHardwareVersion') }}</div>
                    <div class="value">{{ general_info.battery_hardware_version }}</div>
                </div>
                <div class="block">
                    <div class="label">{{ $t('bikeInfo.displayHardwareVersion') }}</div>
                    <div class="value">{{ general_info.display_hardware_version }}</div>
                </div>
            </div>

            <!-- <div class="qrcode_box" v-if="qrcodeUrl !== '' && qrcodeUrl !== '-'">
                <QRCodeVue class="qrcode_img" :value="qrcodeUrl" :size="100"></QRCodeVue>
                <div class="qrcode_text">{{ t('bikeInfo.motorQRCode') }}</div>
            </div> -->

            <div class="qrcode_box_container">
                <div class="qrcode_box" v-if="qrcodeUrl !== '' && qrcodeUrl !== '-'">
                    <QRCodeVue class="qrcode_img" :value="qrcodeUrl" :size="100"></QRCodeVue>
                    <div class="qrcode_text">{{ t('bikeInfo.motorQRCode') }}</div>
                </div>
                <div class="qrcode_box barcode_box" v-if="(userInfo.tenant_id == 0 || userInfo.tenant_id == 1) && barcodeUrl !== '' && barcodeUrl !== '-'">
                    <QRCodeVue class="qrcode_img" :value="barcodeUrl" :size="100"></QRCodeVue>
                    <div class="qrcode_text">{{ t('bikeInfo.ebikeQRcode') }}</div>
                </div>
            </div>

        </div>

        <div class="system_info">
            <div class="title">{{ $t('bikeInfo.systemInformation') }}</div>
            <a-table 
                :columns="table.columns" 
                :data-source="table.data" 
                :bordered="table.configs.bordered"
                :showHeader="table.configs.showHeader" 
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :pagination="table.configs.pagination"
            >
                <template #bodyCell="{ column, record }"> 
                    <template v-if="column.dataIndex === 'config_name'">
                        {{ record.config_name }}
                        <span v-if="record.require" style="color:red;">*</span>
                        <a-tooltip placement="topLeft">
                            <template #title>
                                <span class="configDesc">{{ record.config_desc }}</span>
                            </template>
                            <img v-if="record.config_desc" class="question_img" src="@/assets/image/question.png" alt="">
                        </a-tooltip>
                    </template>
                </template>
            </a-table>

            <a-table 
                :columns="table2.columns" 
                :data-source="table2.data" 
                :bordered="table2.configs.bordered"
                :showHeader="table2.configs.showHeader" 
                :pagination="table2.configs.pagination"
            >
                <template #bodyCell="{ column, record }"> 
                    <template v-if="column.dataIndex === 'config_name'">
                        {{ record.config_name }}
                        <span v-if="record.require" style="color:red;">*</span>
                        <a-tooltip placement="topLeft">
                            <template #title>
                                <span class="configDesc">{{ record.config_desc }}</span>
                            </template>
                            <img v-if="record.config_desc" class="question_img" src="@/assets/image/question.png" alt="">
                        </a-tooltip>
                    </template>
                </template>
            </a-table>
        </div>

        <div class="bike_info">
            <div class="title">{{ $t('bikeInfo.ebikeInfo') }}</div>
            <div class="block">
                <div class="label">{{ $t('bikeInfo.motorInstallationAngle') }}</div>
                <div class="value">{{ bike_info.motor_installation_angle }}</div>
            </div>
            <div class="block">
                <div class="label">{{ $t('bikeInfo.modelSpeedSensor') }}</div>
                <div class="value">{{ bike_info.speed_sensor }}</div>
            </div>
            <div class="block">
                <div class="label">{{ $t('bikeInfo.amountFrontChainring') }}</div>
                <div class="value">{{ bike_info.front_chain_teeth }}</div>
            </div>
            <div class="block">
                <div class="label">{{ $t('bikeInfo.maxTeethChainring') }}</div>
                <div class="value">{{ bike_info.max_chain_teeth }}</div>
            </div>
            <div class="block">
                <div class="label">{{ $t('bikeInfo.minTeethChainring') }}</div>
                <div class="value">{{ bike_info.min_chain_teeth }}</div>
            </div>

            <div class="gear">
                <div class="external">
                    <div class="subTitle">{{ $t('bikeInfo.externalGear') }}</div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.speedsCassette') }}</div>
                        <div class="value">{{ bike_info.speed_cassette }}</div>
                    </div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.maxTeethCassette') }}</div>
                        <div class="value">{{ bike_info.max_rear_teeth }}</div>
                    </div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.minTeethCassette') }}</div>
                        <div class="value">{{ bike_info.min_rear_teeth }}</div>
                    </div>
                </div>
                <div class="internal">
                    <div class="subTitle">{{ $t('bikeInfo.internalGear') }}</div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.maxGearRatio') }}</div>
                        <div class="value">{{ bike_info.max_gear }}</div>
                    </div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.minGearRatio') }}</div>
                        <div class="value">{{ bike_info.min_gear }}</div>
                    </div>
                    <div class="block">
                        <div class="label">{{ $t('bikeInfo.numberTeethSprocket') }}</div>
                        <div class="value">{{ bike_info.sprocket_teeth }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { BikeInfoApi } from '@/api/BikeInfoApi.js';
    import { CyclingApi } from '@/api/CyclingApi.js';
    import { LoginApi } from '@/api/LoginApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate, exportFile } from '@/utils/global';
    import QRCodeVue from 'qrcode.vue'

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.BikeInfo',
        menu_desc: 'menu.subBikeInfo',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const searchForm = reactive({
        frame_number: null,
        assembly_code: null,
        tenant_id:null,
    })
    const frameNumberOptions = ref([])
    const motorCodeOptions = ref([])
    const exportLoading = ref(false)
    const exportBtnDisabled = ref(true)
    const qrcodeUrl = ref('')
    const fetching = ref(false)
    const tenantOptions = ref([])
    const barcodeUrl = ref('')

    const general_info = ref({
        picture_url:'',
        sku: "-",
        brand: "-",
        color: "-",
        drive_unit_model: "-",
        model_year: "-",
        bike_model: "-",
        offline_origin: "-",
        offline_time: "-",
        triple_id: "-",
        battery_serial_number: "-",
        display_serial_number: "-",
        key_serial_number:'-',
        motor_hardware_version:'-',
        battery_hardware_version: "-",
        display_hardware_version: "-",
        motor_software_version: "-",
        battery_software_version: "-",
        display_software_version: "-",
    })

    const bike_info = ref({
        motor_installation_angle:'-',
        speed_sensor:'-',
        front_chain_teeth:'-',
        max_chain_teeth:'-',
        min_chain_teeth:'-',
        speed_cassette:'-',
        max_rear_teeth:'-',
        min_rear_teeth:'-',
        max_gear:'-',
        min_gear:'-',
        sprocket_teeth:'-',
    })

    const table = ref({
        data: [
            {
                config_name:'Torque',
                eco: '-',
                tour: '-',
                turbo: '-',
            },
            {
                config_name:'Assistance level',
                eco: '-',
                tour: '-',
                turbo: '-',
            },
            {
                config_name:'Riding dynamics',
                eco: '-',
                tour: '-',
                turbo: '-',
            },
            {
                config_name:'Restistance compensation',
                eco: '-',
                tour: '-',
                turbo: '-',
            },
        ],
        columns: [
            {
                title: t('bikeInfo.item'),
                dataIndex: 'config_name',
                key: 'config_name',
                align:'left',
                width: '20%',
                resizable: true,
            },
            {
                title:t('bikeInfo.eco'),
                dataIndex: 'eco',
                key: 'eco',
                align:'center',
                resizable: true,
            },
            {
                title:t('bikeInfo.tour'),
                dataIndex: 'tour',
                key: 'tour',
                align:'center',
                resizable: true,
            },
            {
                title:t('bikeInfo.turbo'),
                dataIndex: 'turbo',
                key: 'turbo',
                align:'center',
                resizable: true,
            },
        ],
        configs: {
            scroll: {},
            rowSelection: false,
            loading: true,
            bordered:false,
            showHeader:true,
            pagination: false,
        },
    })

    const table2 = ref({
        data: [
            {
                config_name:t('bikeInfo.walkModeSpeed'),
                config_value: '-',
            },
            {
                config_name:t('bikeInfo.wheelCircumference'),
                config_value: '-',
            },
            {
                config_name:t('bikeInfo.maxSupportedSpeed'),
                config_value: '-',
            },
            {
                config_name:t('bikeInfo.maxTorque'),
                config_value: '-',
            },
        ],
        columns: [
            {
                dataIndex: 'config_name',
                key: 'config_name',
                align:'left',
                width: '20%',
                resizable: true,
            },
            {
                dataIndex: 'config_value',
                key: 'config_value',
                align:'center',
                resizable: true,
            },
        ],
        configs: {
            scroll: {},
            rowSelection: false,
            loading: true,
            bordered:false,
            showHeader:false,
            pagination: false,
        },
    })


    const handleSelectChange = (type, val)=>{
        console.log(type, 'type', val, '电机总成')
        let vehicle_id = ''
        if(type == 'frame_number'){
            searchForm.assembly_code = null
            vehicle_id = frameNumberOptions.value.find(item=>item.value == val)?.vehicle_id || ''
        }else if(type == 'assembly_code'){
            searchForm.frame_number = null
            vehicle_id = motorCodeOptions.value.find(item=>item.value == val)?.vehicle_id || ''
        }else if(type == 'tenant'){
            searchForm.frame_number = null
            searchForm.assembly_code = null
        }

        getFrameAndMotor()

        console.log(!searchForm.frame_number , !searchForm.assembly_code, 'searchForm')
        if(!searchForm.frame_number && !searchForm.assembly_code){
            qrcodeUrl.value = ''
            barcodeUrl.value = ''
            for (const key in general_info.value) {
                general_info.value[key] = key == 'picture_url'? '' : '-'
            }
            for (const key in bike_info.value) {
                bike_info.value[key] = '-'
            }
            table.value.data.forEach(item=>{
                item.eco = '-'
                item.tour = '-'
                item.turbo = '-'
            })
            table2.value.data.forEach(item=>{
                item.config_value = '-'
            })
            exportBtnDisabled.value = true
        }else{
            getBikeInfo()
            if(userInfo.value.tenant_id == 1 || userInfo.value.tenant_id == 0) getBarCode(vehicle_id)
            exportBtnDisabled.value = false
        }
        
    }

    const handleSearch = ()=>{
        if(!searchForm.frame_number && !searchForm.assembly_code){
            message.error(t('bikeInfo.exportTip'))
            return
        }
        getBikeInfo()
        exportBtnDisabled.value = false
    }

    // 获取车架号、电机总成
    const getFrameAndMotor = async (val, type)=>{
        let param = {   
            tenant_id: userInfo.value.tenant_id == 1? searchForm.tenant_id : userInfo.value.tenant_id,
        }
        if(type && type == 'frame_number') param.frame_number = val
        if(type && type == 'assembly_code') param.triple_id = val

        fetching.value = true
        let res = await CyclingApi.getInstance().getFrameAndMotor(param, 1, 50)
        if(res.code === 0){
            fetching.value = false
            frameNumberOptions.value = []
            motorCodeOptions.value = []

            res.data.records.length > 0 && res.data.records.forEach(item=>{
                if(item.frame_number){
                    frameNumberOptions.value.push({
                        label: item.frame_number,
                        value: item.frame_number,
                        user_id: item.user_id,
                        vehicle_id: item.id,
                    })
                }
                
                if(item.triple_id){
                    motorCodeOptions.value.push({
                        label: item.triple_id,
                        value: item.triple_id,
                        user_id: item.user_id,
                        vehicle_id: item.id,
                    })
                }
            })
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取车辆信息
    const getBikeInfo = async()=>{
        let frame_number = searchForm.frame_number || ''
        let assembly_code = searchForm.assembly_code || ''
        let res = await BikeInfoApi.getInstance().getBikeInfo(userInfo.value.id, frame_number, assembly_code)
        if(res.code === 0){
            general_info.value = res.data.general_info
            general_info.value.picture_url = res.data.general_info.picture_url == undefined? '' : res.data.general_info.picture_url

            general_info.value.key_serial_number = res.data.general_info.key_serial_number == undefined? '-' : res.data.general_info.key_serial_number
            general_info.value.battery_serial_number = res.data.general_info.battery_serial_number == undefined? '-' : res.data.general_info.battery_serial_number
            general_info.value.display_serial_number = res.data.general_info.display_serial_number == undefined? '-' : res.data.general_info.display_serial_number
            general_info.value.motor_software_version = res.data.general_info.motor_software_version == undefined? '-' : res.data.general_info.motor_software_version
            general_info.value.battery_software_version = res.data.general_info.battery_software_version == undefined? '-' : res.data.general_info.battery_software_version
            general_info.value.display_software_version = res.data.general_info.display_software_version == undefined? '-' : res.data.general_info.display_software_version
            general_info.value.motor_hardware_version = res.data.general_info.motor_hardware_version == undefined? '-' : res.data.general_info.motor_hardware_version
            general_info.value.battery_hardware_version = res.data.general_info.battery_hardware_version == undefined? '-' : res.data.general_info.battery_hardware_version
            general_info.value.display_hardware_version = res.data.general_info.display_hardware_version == undefined? '-' : res.data.general_info.display_hardware_version

            bike_info.value = res.data.bike_info
            qrcodeUrl.value = res.data.general_info.triple_id

            let eco_data = res.data.system_info.gears.length > 0? res.data.system_info.gears.find(item => item.gear == 'ECO') : null
            let tour_data = res.data.system_info.gears.length > 0? res.data.system_info.gears.find(item => item.gear == 'TOUR') : null
            let turbo_data = res.data.system_info.gears.length > 0? res.data.system_info.gears.find(item => item.gear == 'TURBO') : null

            table.value.data = [
                    {
                        config_name: t('bikeInfo.torque'),
                        eco: eco_data? eco_data.torque : '-',
                        tour: tour_data? tour_data.torque : '-',
                        turbo: turbo_data? turbo_data.torque : '-',
                    },
                    {
                        config_name:t('bikeInfo.assistanceLevel'),
                        eco: eco_data? eco_data.assist : '-',
                        tour: tour_data? tour_data.assist : '-',
                        turbo: turbo_data? turbo_data.assist : '-',
                    },
                    {
                        config_name:t('bikeInfo.ridingDynamics'),
                        eco: eco_data? eco_data.ride_dynamics : '-',
                        tour: tour_data? tour_data.ride_dynamics : '-',
                        turbo: turbo_data? turbo_data.ride_dynamics : '-',
                    },
                    {
                        config_name:t('bikeInfo.restistanceCompensation'),
                        eco: eco_data? eco_data.compensation : '-',
                        tour: tour_data? tour_data.compensation : '-',
                        turbo: turbo_data? turbo_data.compensation : '-',
                    }
            ]

            table2.value.data = [
                {
                    config_name: t('bikeInfo.walkModeSpeed'),
                    config_value: res.data.system_info.walk_mode_speed? res.data.system_info.walk_mode_speed : '-',
                },
                {
                    config_name: t('bikeInfo.wheelCircumference'),
                    config_value: res.data.system_info.wheel_circumference? res.data.system_info.wheel_circumference : '-',
                },
                {
                    config_name: t('bikeInfo.maxSupportedSpeed'),
                    config_value: res.data.system_info.max_speed? res.data.system_info.max_speed : '-',
                },
                {
                    config_name: t('bikeInfo.maxTorque'),
                    config_value: res.data.system_info.max_torque? res.data.system_info.max_torque : '-',
                }
            ]
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 下载车辆信息数据
    const exportData = async()=>{
        if(!searchForm.frame_number && !searchForm.assembly_code){
            Modal.error({ 
                title: t('base.tip'), 
                content: t('bikeInfo.exportTip'),
                okText: t('base.ok'),
            })
            return
        }
        exportLoading.value = true
        message.info(t('base.exporting'))
        let frame_number = searchForm.frame_number || ''
        let assembly_code = searchForm.assembly_code || ''
        let res = await BikeInfoApi.getInstance().exportInfo(userInfo.value.id, frame_number, assembly_code)
        if(res.status === 200){
            exportFile(res.data, `${t('bikeInfo.bikeInfoData')}.pdf`)
            message.success(t('base.downloadSucceeded'))
            exportLoading.value = false
        }else{
            message.error(res.msg || res.message)
            exportLoading.value = false
        }
    }

    // 获取邦车条码
    const getBarCode = async(vehicle_id)=>{
        let param = { id: vehicle_id }
        let res = await AdvancedFunApi.getInstance().getBarCode(param)
        if(res.code === 0){
            barcodeUrl.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            tenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }
    }

    onMounted(async()=>{
        getFrameAndMotor()
        getTenantList()
    })


</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: 30px;
}

.queryUserTitle{
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: 16px;
    color: #1226AA;
}

.query_box{
    margin-top: 30px;
    margin-bottom: 10px;

    .query_field{
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 5px;
        width: 200px;
    }
}


.general_info{
    display: flex;
    margin-top: 20px;
    padding: 40px 80px;
    background: #fff;
    border-radius: 6px;

    .info_left{
        display: flex;
        flex: 1 1 400px;
        flex-direction: column;

        .img{
            margin-bottom: 60px;
            padding: 47px 0;
        }

        .bike_img{
            max-width: 320px;
        }
    }


    .info_right{
        display: flex;
        flex: 1 1 600px;
        flex-direction: column;

        .right_title{
            margin-bottom: 20px;
            font-size: 32px;
            font-weight: 600;
        }
    }

    .qrcode_box_container{
        display: flex;
        flex-direction: column;

        .qrcode_box{
            display: flex;
            flex-direction: column;

            .qrcode_text{
                margin-top: 5px;
            }

        }

        .barcode_box{
            margin-top: 50px;
        }
    }



    .block{
        display: flex;
        line-height: 27px;
        font-weight: 500;

        .label{
            display:flex;
            flex: 1 1 150px;
            color: #3C4257;
        }

        .value{
            display:flex;
            flex: 4;
            font-weight: 700;
            color: #3C4257;
        }
    }
}

.system_info{
    .title{
        margin: 50px 0 10px;
        font-size: 32px;
        font-weight: 600;
    }
}



.bike_info{
    .title{
        margin: 50px 0 10px;
        font-size: 32px;
        font-weight: 600;
    }

    .block{
        display: flex;
        line-height: 27px;
        font-weight: 500;

        .label{
            display:flex;
            flex: 1 1 150px;
            color: #3C4257;
        }

        .value{
            display:flex;
            flex: 4;
            font-weight: 700;
            color: #3C4257;
        }
    }

    .gear{
        display: flex;
        margin: 40px 0 100px;


        .external{
            display: flex;
            flex: 1;
            flex-direction: column;
            border-right: 1px solid #E3E8EE;
        }

        .internal{
            display: flex;
            flex: 1;
            flex-direction: column;
            padding-left: 100px;
        }

        .subTitle{
            margin: 20px 0;
            font-size: 20px;
            font-weight: 500;
        }

        .block{
            .label{
                flex: 1 1 150px;
            }

            .value{
                flex: 1;
            }
        }

    }
}



.block_last{
    margin-bottom: 20px;
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

::v-deep .ant-table-row{
    .ant-table-cell:nth-of-type(1){
        background:#fafafa;
        font-weight: 500;
    }
}
</style>